module.exports = __webpack_public_path__ + "img/1.a09f92b2.jpg";